export enum TransformerAnchor {
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
  MiddleRight = 'middle-right',
  MiddleLeft = 'middle-left',
  TopCenter = 'top-center',
  BottomCenter = 'bottom-center',
}

export const MoveableDirections = {
  E: [1, 0],
  W: [-1, 0],
  S: [0, 1],
  N: [0, -1],
  SE: [1, 1],
  SW: [-1, 1],
  NE: [1, -1],
  NW: [-1, -1],
}
